module.exports = __webpack_public_path__ + "static/media/Spotted.65e40891.jpeg";